import React from "react"
import Pdf from "react-to-pdf"
import { state, pickerState, turkish, materialState, options, testState } from "./controls/state.js"
import { useSnapshot } from "valtio"
import { carPaintProps, getCarPaintProps, getCarPaintPalette, glassPaintProps, getGlassPaintProps, getGlassPaintPalette } from "./paint/paint.js"
import * as mats from "./models/mats.js"
import Dropdown from "react-dropdown";
import "react-dropdown/style.css";


const ref = React.createRef();

function DownloadBtn () {
  
  const snap = useSnapshot(state)
  const pickerSnap = useSnapshot(pickerState)
  
  // todo: only show brand and series when "kaplama yok"

  const getPaintDetails = (paintType) => {
    var paintName = paintType === "car_paint" ?
    getCarPaintProps(pickerSnap.items[paintType].brand, pickerSnap.items[paintType].series, snap.items[paintType]).name 
    : getGlassPaintProps(pickerSnap.items[paintType].brand, pickerSnap.items[paintType].series, snap.items[paintType]).name  
    
    var paintDisplay = paintType === "car_paint" ?
    getCarPaintProps(pickerSnap.items[paintType].brand, pickerSnap.items[paintType].series, snap.items[paintType]).display 
    : getGlassPaintProps(pickerSnap.items[paintType].brand, pickerSnap.items[paintType].series, snap.items[paintType]).display 


    return snap.items[paintType] === "#ffffff" ? turkish[paintType] + ":\nSeçilmedi" + "\n" :
      turkish[paintType]  + ":\n" +
      pickerSnap.items[paintType].brand + " > " +
      pickerSnap.items[paintType].series + " > " +
      paintDisplay + " - " + 
      paintName + "\n"
  }


  return (
    <div>
      <Pdf targetRef={ref} filename="bizimoto.pdf">
        {({ toPdf }) => <div class="download_wrapper"><img src="icons/pdf.png" class="download_image" onClick={toPdf}></img></div>}
      </Pdf>
      <div ref={ref} class="pdf_contents">
        
        <br/>
        <img src="logo/company_main_logo.png" style={{width:"500px", height:"auto"}}></img> <br></br>
        
        <div class="pdf_hr_wrapper"><hr/></div>

        Bizim Oto Garaj™ araç kaplama ve cam filmi düzenleme özetiniz aşağıdaki gibidir: <br></br>
        
        <br></br>
        <br></br>
        {getPaintDetails("car_paint")}

        <pre/>
        {getPaintDetails("front_glass")}

        <pre/>
        {getPaintDetails("front_side_glass")}

        <pre/>
        {getPaintDetails("back_side_glass")}

        <pre/>
        {getPaintDetails("back_glass")}

        <br></br>
        <br></br>
        Bu belgeyi Bizim Oto Garaj™ müşteri temsilciniz ile paylaşınız.
      </div>
      <div class="pdf_overlay">
         Overlay to make above div invisible. Do not delete this.
      </div>
    </div>
  )
}

function ScreenInfo() {
  return (
  <>
    <div class="bottom_info_div">
      <p> Araç Kaplaması için aracın üzerine tıklayınız. </p>
      <p> Cam Filmi uygulamak için cam bölgesinin üzerine tıklayınız. </p>
    </div>
  </>
  )
}

function MaterialSelector(){

  const snap = useSnapshot(state)
  const materialSnap = useSnapshot(materialState)
  const testSnap = useSnapshot(testState)

  function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  const updateMaterial = async (material_name) => {    
    //var prev_color = (' ' + snap.items[snap.current]).slice(1);
    //options.loading = true;
    materialState.items[snap.current] = "01_default";
    state.items[snap.current] = "#ffffff";
    // Theres a bug with mats so color needs to be repainted, two triggers with async
    await sleep(10)
    materialState.items[snap.current] = material_name;
    state.items[snap.current] = snap.items[snap.current];
    
    //options.loading = false;
  }

  function getMaterialList() {
    const custom = mats.getMaterial()

    var carMaterialList = []
    var glassMaterialList = []

    const keys = Object.keys(custom)
    for (var i = 0; i < keys.length ; i++){

      var currKey = keys[i];
      if ( currKey.startsWith("c")){
        carMaterialList.push(currKey.substring(1))
      } else if (currKey.startsWith("fg")){
        glassMaterialList.push(currKey.substring(2))
      }

    }

    carMaterialList.sort()
    glassMaterialList.sort()
    //console.log(carMaterialList)
    //console.log(glassMaterialList)

    return [carMaterialList, glassMaterialList]
  }

  var carMatList, glassMatList;
  [carMatList, glassMatList] = getMaterialList()
  
  const changeVisible = () => {
    console.log(visible)
    console.log(!visible)
    visible = !visible
    return visible
  }
  //console.log(carMatList, glassMatList)
  /*
          <div onClick = {() => {materialState.items[snap.current] = "02_shiny";}}>
          <p> Shiny </p>
        </div>

          <div onClick = {() => {updateMaterial("05_porcelain")}}>
          <p> Degistir </p>
        </div>


                  Materyal: {"  "}
          {
                snap.items[snap.current] === null ?  "" : materialSnap.items[snap.current] 
          }
          
          {testSnap.visible ? '  Test' : ""}
        */

  return (
    <>
      <div class="test_logo_wrapper" style = {{ color:'#e30513', fontSize:'1.1em'}} onClick= {() => {testState.visible = !testSnap.visible}}>
        <img src="icons/checkmark.svg" class = { testSnap.visible ? "test_logo_active" : ""} style={{ width: "25px"}} ></img>
      </div>
      
      <div class = "test_info_div" style={{ display: testSnap.visible  ? "block" : "none" }}>
        <div style={{ display: turkish[snap.current] && snap.items[snap.current] === "#ffffff"  ? "block" : "none" }}>
          <p>Renk Seçiniz</p> 
        </div>
        <div style={{ display: turkish[snap.current] && testSnap.visible && snap.items[snap.current] !== "#ffffff"  ? "block" : "none" }}>

          <p>
            Materyal Seçiniz
          </p>

          <Dropdown
            options={snap.current === "car_paint" ? carMatList : glassMatList}
            value={materialSnap.items[snap.current]}
            onChange={(selected) => {
              updateMaterial(selected.value)
              return true
            }}
            placeholder="Select an option"
          />

        </div>
      </div>
    </>
    )
}

export {DownloadBtn, ScreenInfo, MaterialSelector}